import { type FC } from 'react';

import { Message } from '#packages/web/foundations/feedback/message';
import { ActionButton } from '#packages/web/foundations/buttons/action-button';

import { MessagePage, type MessagePageProps } from './message-page';

export type EmptyPageProps = MessagePageProps & {
  /**
   * Handler for action button click.
   * This overrides the onClick of the actionButton if both are provided.
   */
  onActionButtonClick?: () => void;
};

export const EmptyPage: FC<EmptyPageProps> = ({
  image = (
    <img
      src="https://placehold.co/200x100/dddddd/999999"
      alt="No items"
      style={{ display: 'flex' }}
    />
  ),
  message = <Message>No items to display.</Message>,

  onActionButtonClick,
  action = <ActionButton onClick={onActionButtonClick}>Create</ActionButton>,

  ...props
}) => (
  <MessagePage image={image} message={message} action={action} {...props} />
);
